import { Box, Typography, Stack, TextField, Backdrop, CircularProgress, MenuItem, Divider, Button, FormControlLabel, Checkbox } from "@mui/material";
import React from "react";
import { Context } from "../../App";
import OffSpe from "../sections/OffrandesSpeSection";
import { DonContext } from "../../pages/StandardDon";


export default function StandardDonForm() {
  const { region } = React.useContext(Context);
  const { isAnonyme, setIsAnonyme, egliseNum, setEglise, dime, setDime, off_global, setOff_global, offrandesFederale, setOffrandesFederale, offrandesLocale, setOffrandesLocale, total} = React.useContext(DonContext);
  
  const [load, setLoad] = React.useState(true)
  const [eglises, setEglises] = React.useState([])

  const [offrandesFederaleOptions, setOffrandesFederaleOptions] = React.useState([]);
  const [offrandesLocaleOptions, setOffrandesLocaleOptions] = React.useState([]);

  const eglise = React.useMemo(()=> eglises.find(e => e.number === egliseNum), [eglises, egliseNum]);
  

  React.useEffect(()=>{
    setLoad(true);
    const query = new URLSearchParams({ region, eglise: egliseNum, exercice: new Date().getFullYear() }).toString();

    fetch(process.env.REACT_APP_THYBA_API_URL.concat('/public/comptes/offrandes?'+ query), {method: 'GET'})
    .then((res) => res.json()).then((data) => {
      setOffrandesFederaleOptions(data.fedComptes);
      setOffrandesLocaleOptions(data.localComptes);
      setOffrandesLocale([{libelle:'', montant:0, compte:''}]);
      console.log(data);
      setLoad(false);
    })
    .catch((err) => {
      console.error("Error fetching offrandes fédérales:", err);
    });
  }, [egliseNum])

  React.useEffect(()=>{
    const query = new URLSearchParams({ region, type:'église' }).toString();

    fetch(process.env.REACT_APP_THYBA_API_URL.concat('/public/eglises/by?'+ query), {method: 'GET'})
      .then((res) => res.json())
      .then((data) => { 
        setEglises(data.filter(e => e.type==='église'));
        setLoad(false);
      })
      .catch((err) => {
        console.error("Error fetching eglises:", err);
        setLoad(false);
      });
  }, [region])

  React.useEffect(()=>{
    
  }, [eglises])

  return (
    <Box component='form' display={"flex"} flexDirection="column" gap={2} sx={{ mt: 2, mb:4, px: { xs: 2, sm: 0 } }}>
      <Typography variant="h1" component="h1" sx={{ fontSize: { xs: '1.75rem', sm: '2.5rem' } }}>Faire un don</Typography>

      <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "stretch", sm: "center" }} justifyContent={'space-between'} gap={{ xs: 2, sm: 0 }}>
        <FormControlLabel control={
          <Checkbox checked={isAnonyme} onChange={(e) => setIsAnonyme(e.target.checked)} />
        } label="Don anonyme" sx={{ order: { xs: 2, sm: 1 } }} />

        <TextField select value={egliseNum} onChange={(e)=>setEglise(e.target.value)} label='Église' size="small"
        sx={{width:{ xs: '100%', sm: '40%' }, maxWidth: { xs: 'none', sm: 400 }, backgroundColor:'white', order: { xs: 2, sm: 2 }}}>
          <MenuItem value=''>Sélectionner une église</MenuItem>
          {eglises.sort((a, b) => a.nom.localeCompare(b.nom)).map((e) => (
            <MenuItem key={e._id} value={e.number}>{e.nom}</MenuItem>
          ))}
        </TextField>
      </Stack>
        
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={2} alignItems={{ xs: 'stretch', sm: 'center' }}>
        <Typography variant="h5" color='primary' sx={{fontWeight:'bold', mr: { xs: 0, sm: 5 }, fontSize: { xs: '1.25rem', sm: '1.5rem' }, mb: { xs: 1, sm: 0 }}}>Dîme:</Typography>
        <TextField fullWidth label="Montant €" type="number" slotProps={{ step:"0.01", min:'0'}}
        value={dime} onFocus={()=>{if(dime===0) setDime('')}}
        onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0) {
            setDime(Number(e.target.value))
        }else if(e.target.value===''){
            setDime('')
        }}}/>
      </Stack>
        
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={2} alignItems={{ xs: 'stretch', sm: 'center' }}>
        <Typography variant="h5" color='primary' sx={{fontWeight:'bold', flexShrink:0, mr: { xs: 0, sm: 5 }, fontSize: { xs: '1.25rem', sm: '1.5rem' }, mb: { xs: 1, sm: 0 }}}>Offrande globale:</Typography>
        <TextField fullWidth label="Montant €" type="number" slotProps={{ step:"0.01", min:'0'}}
        value={off_global} onFocus={()=>{if(off_global===0) setOff_global('')}}
        onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
            setOff_global(Number(e.target.value))
        }else if(e.target.value===''){
            setOff_global('')
        }}}/>
      </Stack>

      <Divider sx={{width: { xs: '80%', sm: '60%' }, borderColor: 'primary.main', opacity:0.3, alignSelf:'center', mt: { xs: 3, sm: 4 }}}/>
      <Typography variant="h5" color='primary' sx={{fontWeight:'bold', flexShrink:0, mr: { xs: 0, sm: 5 }, fontSize: { xs: '1.1rem', sm: '1.5rem' }, textAlign: { xs: 'center', sm: 'left' }}}>Offrandes spécifiées fédérales et soutien aux institutions</Typography>
      <OffSpe {...{eglises, offSpe: offrandesFederale, setOffSpe: setOffrandesFederale, offSpeOptions: offrandesFederaleOptions, setOffSpeOptions: setOffrandesFederaleOptions}}/>

      {eglise&&<><Divider sx={{width: { xs: '80%', sm: '60%' }, borderColor: 'primary.main', opacity:0.3, alignSelf:'center', mt: { xs: 3, sm: 4 }}}/>
      <Typography variant="h5" color='primary' sx={{fontWeight:'bold', flexShrink:0, mr: { xs: 0, sm: 5 }, fontSize: { xs: '1.1rem', sm: '1.5rem' }, textAlign: { xs: 'center', sm: 'left' }}}>Offrandes spécifiées église</Typography>
      <OffSpe {...{eglises, offSpe: offrandesLocale, setOffSpe: setOffrandesLocale, offSpeOptions: offrandesLocaleOptions}}/></>}

      <FormControlLabel control={
        <Checkbox checked={isAnonyme} onChange={(e) => setIsAnonyme(e.target.checked)} />
      } label="Don anonyme" sx={{alignSelf:'center'}} />

      <Typography variant="h5" color='primary' sx={{fontWeight:'bold', marginBlock:2, marginLeft: { xs: 0, sm: 5 }, textAlign: { xs: 'center', sm: 'left' }, fontSize: { xs: '1.25rem', sm: '1.5rem' }}}>TOTAL DON: {total?.toFixed(2)}€</Typography> 

      <Backdrop open={load}><CircularProgress/></Backdrop>
    </Box>
  );
}